import React, { useState } from 'react'
import './searchBar.css'

const SearchBar = ({ onSearch, placeholder = 'Buscar vehículos...', onClear }) => {
  const [searchTerm, setSearchTerm] = useState('')

  const handleSubmit = e => {
    e.preventDefault()
    if (searchTerm.trim()) {
      onSearch(searchTerm.trim())
    }
  }

  const handleChange = e => {
    const value = e.target.value
    setSearchTerm(value)

    // Si es borra tot, netejar resultats
    if (value.trim() === '' && onClear) {
      onClear()
    }
  }

  const handleClear = () => {
    setSearchTerm('')
    if (onClear) {
      onClear()
    }
  }

  return (
    <div className='search-bar'>
      <form onSubmit={handleSubmit}>
        <input type='text' className='search-input' placeholder={placeholder} value={searchTerm} onChange={handleChange} />
        {searchTerm && (
          <button type='button' className='clear-button' onClick={handleClear} title='Limpiar búsqueda'>
            ✕
          </button>
        )}
        <button type='submit' className='search-button'>
          <svg className='lupa-icon' viewBox='0 0 24 24' width='24' height='24'>
            {/* Dibuix de la lupa */}
            <path
              fill='currentColor'
              d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'
            />
          </svg>
        </button>
      </form>
    </div>
  )
}

export default SearchBar
